import Vue from "vue";

Vue.component("wto-tag-input-ids", {
	props: ["label", "placeholder", "items", "list", "ids", "isReadonly", "labelPosition", "errorMessage", "maxTags", "nonEllipsis", "helperCode", "detailedEmptyStates"],
	data() {
		return {
			selectItems: [],
			options: []
		};
	},
	methods: {
		getFilteredItems(text) {
			const normalize = (str) =>
				str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

			const normalizedText = normalize(text);

			this.options = this.items.filter((option) => {
				const normalizedOptionText = normalize(option.text);
				return (
					!this.computedValue.includes(option) &&
					normalizedOptionText.indexOf(normalizedText) >= 0
				);
			});
		},
		getValues: function (ids) {
			const returnValue = [];
			const items = this.items;

			ids.forEach(function (id) {
				const item = items.filter(t => t.value === id);
				if (item.length > 0) {
					returnValue.push(item[0]);
				}
			});

			return returnValue;
		},
		getDataSourceMultiText: (dataSource, value) => {
			if (dataSource) {
				const items = dataSource.filter(i => value.includes(i.value));
				var returnValue = "";
				items.forEach(function (item) {

					returnValue += `${item.text}; `;
				});
				return returnValue;
			}
			return "";
		},
		beforeAdd: function () {
			let result = this.options.length > 0;
			if (!result) {
				this.options = this.items;
			}
			return result;
		},
		onDataChange: function(){
			this.$emit('on-data-change')
		}
	},
	mounted() {
		this.options = this.items;
	},
	watch: {
		items: function (val) {
			this.options = val;
		},
		computedValue: function(val){
			this.options = this.items.filter((option) => {
				return !val.includes(option);
			});
		}
	},
	computed: {
		isAllSelected: function () {
			return this.detailedEmptyStates
				&& this.items
				&& this.items.length > 0
				&& this.computedValue.length >= this.items.length;
		},
		noItemMessage: function () {
			if (!this.detailedEmptyStates) {
				return window.labels.thereAreNoItems;
			}
			if (!this.items || this.items.length === 0) {
				return window.labels.noAvailableData;
			}
			if (this.computedValue.length >= this.items.length) {
				return window.labels.allItemsSelected;
			}
			return window.labels.noMatchingItems;
		},
		computedValue: {
			get() {
				const ids = this.ids;
				if (!ids || ids.length === 0) return [];
				const val = this.getValues(ids);
				return val;
			},
			set(value) {
				if (value) {
					let texts = [];
					let ids = [];
					value.forEach(function (item) {
						texts.push(item.text);
						ids.push(item.value);
					});

					if (this.list) {
						this.$emit("update:list", texts);
					}

					this.$emit("update:ids", ids);
				}
			}
		}
	},
	template: `
		<b-field :label-position="labelPosition" :label="label" :type="errorMessage ? 'is-danger' : ''" :message="errorMessage">
			<b-taginput v-if="!isReadonly" @input="onDataChange" v-model="computedValue" :maxtags="maxTags" :before-adding="beforeAdd" :data="options" autocomplete ref="taginput" field="text" :ellipsis="nonEllipsis ? false : true" :open-on-focus="!isAllSelected" :placeholder="placeholder" @typing="getFilteredItems" expanded>
				<template v-slot="props"><span style="white-space: pre-line;">{{ props.option.text }}</span></template>
				<template #empty><span v-if="!isAllSelected">{{ noItemMessage }}</span></template>
			</b-taginput>
			<div v-if="isReadonly" class="textarea wto-textarea-editor-readonly" style="min-height: 60px !important">{{ getDataSourceMultiText(items, ids) }}</div>
			<p class="control" v-if="helperCode">
				<helper-icon :code-to-display="helperCode" :size-dimension="'is-large'">
				</helper-icon>
			</p>
		</b-field>
	`
});